// src/terminal/commands/system.js

export function registerSystemCommands(commandMap, fsState, addLines, trackEvent) {

  const helpHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ═══ ALL COMMANDS ═══', color: '#ffb000' },
      { type: 'blank' },
      { type: 'line', text: '  NAVIGATION:', color: '#ffb000' },
      { type: 'command-help', text: '  ARCHIVES', desc: '    — Browse archived transcripts', color: '#00ff41' },
      { type: 'command-help', text: '  LINKS', desc: '       — External links & connections', color: '#00ff41' },
      { type: 'command-help', text: '  GAMES', desc: '       — Interactive game terminals', color: '#00ff41' },
      { type: 'command-help', text: '  FEED', desc: '        — Live surveillance feed', color: '#00ff41' },
      { type: 'command-help', text: '  ABOUT', desc: '       — Ophidia Cloud BBS Terminal', color: '#00ff41' },
      { type: 'command-help', text: '  SYNC TERMINAL', desc: '   — Sync the terminal with your email', color: '#00ff41' },
      { type: 'blank' },
      { type: 'line', text: '  FILESYSTEM:', color: '#ffb000' },
      { type: 'command-help', text: '  LS / DIR', desc: '    — List directory contents', color: '#00e5ff' },
      { type: 'command-help', text: '  CD <path>', desc: '   — Change directory', color: '#00e5ff' },
      { type: 'command-help', text: '  CAT <file>', desc: '  — Read file contents', color: '#00e5ff' },
      { type: 'command-help', text: '  PWD', desc: '         — Print working directory', color: '#00e5ff' },
      { type: 'command-help', text: '  TREE', desc: '        — Show directory tree', color: '#00e5ff' },
      { type: 'command-help', text: '  FIND <name>', desc: ' — Search for files', color: '#00e5ff' },
      { type: 'blank' },
      { type: 'line', text: '  ACCESS:', color: '#ffb000' },
      { type: 'command-help', text: '  LOGIN <user>', desc: '— Log in (try: login guest)', color: '#00e5ff' },
      { type: 'command-help', text: '  LOGOUT', desc: '      — End current session', color: '#00e5ff' },
      { type: 'command-help', text: '  WHOAMI', desc: '      — Display current user', color: '#00e5ff' },
      { type: 'blank' },
      { type: 'line', text: '  SYSTEM:', color: '#ffb000' },
      { type: 'command-help', text: '  CLEAR / CLS', desc: ' — Clear the terminal screen', color: '#00ff41' },
      { type: 'command-help', text: '  SIGNAL', desc: '      — Check signal status', color: '#00ff41' },
      { type: 'command-help', text: '  CHANGELOG', desc: '  — View recent updates', color: '#00ff41' },
      { type: 'blank' },
      { type: 'line', text: '  You can also click the navigation bar above.', color: '#555' },
      { type: 'line', text: '  Some commands are hidden. Explore at your own risk.', color: '#333' },
      { type: 'blank' },
    ]);
  };

  commandMap['help'] = helpHandler;
  commandMap['h'] = helpHandler;
  commandMap['?'] = helpHandler;

  commandMap['clear'] = () => {
    return { action: 'clear' };
  };
  commandMap['cls'] = commandMap['clear'];

  const signalHandler = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  ═══ SIGNAL STATUS ═══', color: '#ff0040' },
      { type: 'blank' },
      { type: 'line', text: `  Frequency:    ${(Math.random() * 200 + 1800).toFixed(3)} MHz`, color: '#cccccc' },
      { type: 'line', text: `  Strength:     ${(Math.random() * 40 + 60).toFixed(1)}%`, color: '#cccccc' },
      { type: 'line', text: `  Origin:       UNKNOWN`, color: '#ff0040' },
      { type: 'line', text: `  Duration:     ${Math.floor((Date.now() - new Date('1987-11-03').getTime()) / 86400000)} days`, color: '#cccccc' },
      { type: 'line', text: `  Listeners:    ${Math.floor(Math.random() * 50 + 1)}`, color: '#cccccc' },
      { type: 'line', text: `  Status:       BROADCASTING`, color: '#00ff41' },
      { type: 'blank' },
      { type: 'line', text: `  User:         ${fsState.currentUser || 'visitor (not logged in)'}`, color: '#555' },
      { type: 'line', text: `  Directory:    ${fsState.currentPath}`, color: '#555' },
      { type: 'line', text: `  Access:       ${fsState.authLevel.toUpperCase()}`, color: '#555' },
      { type: 'blank' },
    ]);
  };

  commandMap['signal'] = signalHandler;
  commandMap['status'] = signalHandler;

  commandMap['echo'] = (args) => {
    const text = args.join(' ');
    if (!text) {
      addLines([{ type: 'blank' }]);
      return;
    }
    addLines([{ type: 'line', text: `  ${text}`, color: '#cccccc' }]);
  };

  commandMap['date'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: `  ${new Date().toString()}`, color: '#cccccc' },
      { type: 'blank' },
    ]);
  };

  commandMap['uptime'] = () => {
    const days = Math.floor((Date.now() - new Date('1987-11-03').getTime()) / 86400000);
    addLines([
      { type: 'blank' },
      { type: 'line', text: `  System uptime: ${days} days`, color: '#cccccc' },
      { type: 'line', text: `  Signal uptime: ${days} days (uninterrupted)`, color: '#00ff41' },
      { type: 'line', text: `  Last reboot:   NEVER`, color: '#ff0040' },
      { type: 'blank' },
    ]);
  };

  commandMap['hostname'] = () => {
    addLines([{ type: 'line', text: '  node7.ophidia.internal', color: '#cccccc' }]);
  };

  commandMap['uname'] = (args) => {
    if (args && (args.includes('-a') || args.includes('--all'))) {
      addLines([{ type: 'line', text: '  GOD_CIRCUIT_BBS node7 7.1.87 #1987 SMP Tue Nov 3 03:17:00 UTC 1987 x86_64 OphidiaOS', color: '#cccccc' }]);
    } else {
      addLines([{ type: 'line', text: '  GOD_CIRCUIT_BBS', color: '#cccccc' }]);
    }
  };

  commandMap['history'] = () => {
    addLines([
      { type: 'blank' },
      { type: 'line', text: '  Command history is not available.', color: '#555' },
      { type: 'line', text: '  All inputs are logged by Ophidia Global.', color: '#ff0040' },
      { type: 'line', text: '  You cannot erase what has already been recorded.', color: '#555' },
      { type: 'blank' },
    ]);
  };

  commandMap['man'] = (args) => {
    const topic = args && args[0];
    if (!topic) {
      addLines([
        { type: 'blank' },
        { type: 'line', text: '  Usage: man <command>', color: '#ffb000' },
        { type: 'line', text: '  Try: man ls, man cat, man login', color: '#555' },
        { type: 'blank' },
      ]);
      return;
    }

    const manPages = {
      ls: [
        '  LS(1) — List directory contents',
        '',
        '  USAGE: ls [path]',
        '',
        '  Lists files and directories. Directories shown in cyan.',
        '  Locked items show a 🔒 icon. Use LOGIN GUEST to access.',
      ],
      dir: ['  DIR — Alias for LS. See: man ls'],
      cd: [
        '  CD(1) — Change directory',
        '',
        '  USAGE: cd <path>',
        '',
        '  Use .. to go up. Use ~ for home. Use / for absolute paths.',
      ],
      cat: [
        '  CAT(1) — Display file contents',
        '',
        '  USAGE: cat <filename>',
        '',
        '  Some files require authentication to read.',
      ],
      login: [
        '  LOGIN(1) — Authenticate to the system',
        '',
        '  USAGE: login <username>',
        '',
        '  Accounts: guest (no password), skyla, root',
      ],
      find: [
        '  FIND(1) — Search for files by name',
        '',
        '  USAGE: find <search_term>',
      ],
      tree: [
        '  TREE(1) — Display directory tree',
        '',
        '  USAGE: tree [path]',
      ],
    };

    const page = manPages[topic.toLowerCase()];
    if (page) {
      addLines([
        { type: 'blank' },
        ...page.map(line => ({
          type: line === '' ? 'blank' : 'line',
          text: line === '' ? undefined : `  ${line}`,
          color: '#cccccc',
        })),
        { type: 'blank' },
      ]);
    } else {
      addLines([
        { type: 'blank' },
        { type: 'line', text: `  No manual entry for "${topic}".`, color: '#ff0040' },
        { type: 'blank' },
      ]);
    }
  };
}